import React, { useContext, useEffect, useState } from "react";
import HeadingBanner from "../Components/HeadingBanner.jsx";
import Dashboard from "../Components/Dashboard.jsx";
import * as Yup from 'yup'
import { useFormik } from "formik";
import { Logindetail } from "../context/Logindetail.js";
import { bankdetail, baseurl, getBankDetail } from "../api/Pageapi.js";
import { useNavigate } from "react-router-dom";
import { useRazorpay } from "react-razorpay";
import toast from "react-hot-toast";
import { Snackbar, Alert } from "@mui/material";
import { Buy_coupon, capture_payment, generate_coupon } from "../api/Controllapi.js";
import { useCallback } from "react";
import { FaCopy, FaRegClock, FaShareAlt, FaTimes } from "react-icons/fa";
import axios from "axios";
import { FiDownload } from "react-icons/fi";
import { getprofile_fun } from "../api/Dashboardapi.js";


const MyVouchers = ({ settings }) => {
    const { token, detail_info } = useContext(Logindetail);
    const [amount, setAmount] = useState("");
    const [walletbalance, setWalletbalance] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState("online");
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    const showSnack = (message, severity = "success") => {
        setSnackbar({ open: true, message, severity });
    };
    const handleSnackClose = (_, reason) => {
        if (reason === "clickaway") return;
        setSnackbar(prev => ({ ...prev, open: false }));
    };
    const gstPercent = Number(settings[0]?.gst) || 3;
    const gstValue = amount ? (Number(amount) * gstPercent) / 100 : 0;
    // const total = paymentMethod === "wallet" ? Number(amount) : amount ? Number(amount) + gstValue : 0;
    const total = amount
    ? Number(amount) + gstValue
    : 0;

    const [voucherList, setVoucherList] = useState([])
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [cancelVoucherId, setCancelVoucherId] = useState(null);
    const [new_razar_key, setNew_razar_key] = useState(() => {

        return localStorage.getItem("razorpay_key") || "";
    });

    const fetchKey = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}razorpay_key`
            );

            const apiKey = response?.data?.razorpay_key;

            if (!apiKey) {
                throw new Error("Invalid response format");
            }

            const storedKey = localStorage.getItem("razorpay_key");


            if (!storedKey) {
                localStorage.setItem("razorpay_key", apiKey);
                setNew_razar_key(apiKey);
                return;
            }


            if (storedKey !== apiKey) {
                localStorage.setItem("razorpay_key", apiKey);
                setNew_razar_key(apiKey);
                return;
            }


            setNew_razar_key(storedKey);

        } catch (error) {
            console.error("Failed to fetch Razorpay key:", error);
        }
    };

    useEffect(() => {
        fetchKey();
    }, []);

    const fetchWallet = async () => {
        try {
            const res = await getprofile_fun();
            if (res?.data?.user_wallet) {
                setWalletbalance(Number(res.data.user_wallet));
            }
        } catch (error) {
            console.error("Failed to fetch wallet info", error);
        }
    };

    useEffect(() => {
        if (token) fetchWallet();
    }, [token]);







    //addded key
    //  const {new_razar_key} = useContext(RazarDetails)

    //  const new_razar_key = localStorage.getItem('razorpay_key');
    const RAZAR_KEY = new_razar_key;


    const { error, isLoading, Razorpay } = useRazorpay();
    const router = useNavigate();

    const getList = () => {
        generate_coupon()
            .then((res) => {
                setVoucherList(res?.data)
            })
            .catch((e) => {
            })
    }

    const cancelVoucher = async (id) => {
        try {
            await axios.get(`${process.env.REACT_APP_BASE_URL}genrate_coupon_cancel/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            showSnack("Voucher cancelled", "success");
            getList();
        } catch (err) {
            console.error(err);
            showSnack("Cancel failed", "error");
        }
    }
    useEffect(() => {
        getList()
    }, [])


    const handlePayment = useCallback(async () => {
        if (!total || total <= 0) return showSnack("Enter valid amount", "error");

        if (!amount || amount < 500) {
            return showSnack("The minimum amount to buy voucher is ₹500", "error");
        }
        if (amount > 50000) {
            return showSnack("Amount cannot exceed ₹50,000", "error");
        }

        if (paymentMethod === "wallet") {
            if (Number(amount) > walletbalance) {
                return showSnack("Insufficient wallet balance", "error");
            }
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}pay_now_genrate_coupon`,
                    {
                        amount: Number(amount),
                        wallet: true
                    },
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );

                if (response?.data?.error) {
                    return showSnack(response?.data?.message || "Something went wrong!", "error");
                }

                showSnack("Voucher purchased from wallet successfully!", "success");
                setAmount("");
                router("/user/my-vouchers");
                getList();
            } catch (err) {
                console.error(err);
                showSnack(err?.response?.data?.message || "Wallet payment failed", "error");
            }
        } else {
            const options = {
                // key: `${settings[0]?.razor_api_key}`,
                key: RAZAR_KEY,
                amount: total * 100,
                currency: "INR",
                name: "Greenheap",
                description: "Voucher Payment",
                image: "/assets/iocns/__Fav Icon.png",
                handler: async function (res) {
                    const transactionId = res.razorpay_payment_id;
                    try {

                        await Buy_coupon({
                            amount: amount,
                            transaction_id: transactionId,
                            payment_method: "razor_pay",
                            transaction_details: "test"
                        });



                        toast.success("Payment successful!");
                        setAmount("");

                        let resBody = {
                            "paymentId": transactionId,
                            "amount": total
                        }

                        capture_payment(resBody)
                            .then((res) => {
                                // console.log(res)
                                // console.log("done")
                            })
                            .catch((e) => {
                            })


                        router("/user/my-vouchers");
                        getList()

                    } catch (err) {
                        console.error(err);
                        showSnack("Something went wrong!", "error");
                    }
                },
                theme: { color: "#650020" },
            };

            const rzpay = new Razorpay(options);

            rzpay.open();

            rzpay.on("payment.failed", (response) => {
                console.error(response.error);
                showSnack(response.error.description || "Payment failed", "error");
            });
        }
    }, [Razorpay, total, amount, paymentMethod, router, token, RAZAR_KEY]);




    return (
        <>
            <HeadingBanner title={"My Vouchers"} />
            <section>
                <div className="container">
                    <div className="mybankac-layout">
                        <div className="row">


                            <div className="col-xl-3 col-lg-4">
                                <Dashboard setting_data={settings} />
                            </div>


                            <div className="col-xl-9 col-lg-8">


                                <div
                                    className="card shadow-sm p-4 rounded"
                                    style={{
                                        backgroundImage: "url('/assets/images/voucher_bg_main.png')",
                                        backgroundSize: "100% 100%",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat",
                                        color: "#fff",
                                        minHeight: "200px"
                                    }}
                                >

                                    <div className="mybank-head pb-3  mb-3">
                                        <h4 className="m-0 text-light">My Gift Vouchers</h4>
                                    </div>


                                    <div className="form-group col-12 w-100 col-md-8">
                                        <div className="d-flex gap-2">


                                            {/* <input
                                                type="number"
                                                className="form-control w-50 white-text-input bg-light"
                                                placeholder="Enter Amount"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                            /> */}
                                            {/* <input
                                                type="number"
                                                className="form-control w-50 white-inputt"
                                                placeholder="Enter Amount"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                // style={{
                                                //     backgroundColor: "#f8f9fa",
                                                //     color: "#000",
                                                //     border: "1px solid #ced4da",
                                                // }}
                                            /> */}
                                            <div className="input-wrapper w-100">
                                                <input
                                                    type="number"
                                                    className="form-control white-inputt voucher-amount-input"
                                                    placeholder="Enter Amount"
                                                    value={amount}
                                                    onChange={(e) => setAmount(e.target.value)}
                                                    style={{ width: "100%", maxWidth: "300px" }}
                                                />
                                                {paymentMethod === "wallet" && amount && Number(amount) > walletbalance && (
                                                    <small className="text-black d-block mt-1 fw-bold" style={{ textShadow: "0px 1px 2px rgba(0,0,0,0.3)" }}>
                                                        Insufficient balance (Max: ₹{walletbalance.toFixed(2)})
                                                    </small>
                                                )}
                                            </div>
                                        </div>



                                        {/* {paymentMethod !== "wallet" && (
                                            <div className="d-flex justify-content-between mt-3" style={{ maxWidth: "300px" }}>
                                                <h6 className="m-0 text-light fw-bold">GST ({gstPercent}%)</h6>
                                                <h6 className="m-0 text-light fw-bold">{gstValue.toFixed(2)}</h6>
                                            </div>
                                        )} */}
<div
    className="d-flex justify-content-between mt-3"
    style={{ maxWidth: "300px" }}
>
    <h6 className="m-0 text-light fw-bold">
        GST ({gstPercent}%)
    </h6>

    <h6 className="m-0 text-light fw-bold">
        {gstValue.toFixed(2)}
    </h6>
</div>
                                        <div className="d-flex justify-content-between mt-3 pt-3 border-top" style={{ maxWidth: "300px" }}>
                                            <h5 className="m-0 text-light fw-bold">Total</h5>
                                            <h5 className="m-0 text-light fw-bold"><b>{total.toFixed(2)}</b></h5>
                                        </div>

                                        <div className="mt-4" style={{ maxWidth: "400px" }}>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="paymentMethod"
                                                    id="payWallet"
                                                    value="wallet"
                                                    checked={paymentMethod === "wallet"}
                                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                                />
                                                <label className="form-check-label text-light fw-bold" htmlFor="payWallet">
                                                    Pay via wallet
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="paymentMethod"
                                                    id="payOnline"
                                                    value="online"
                                                    checked={paymentMethod === "online"}
                                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                                    style={{ accentColor: "black" }}
                                                />
                                                <label className="form-check-label text-light fw-bold" htmlFor="payOnline">
                                                    Online payment
                                                </label>
                                            </div>
                                            <div className="mt-2 text-light" style={{ fontSize: "14px", height: "18px" }}>
                                                {paymentMethod === "wallet" ? `Available wallet balance: ₹${walletbalance.toFixed(2)}` : "UPI / Card / Net Banking"}
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <button
                                                className="btn btn-light py-2 text-dark fw-bold voucher-buy-btn"
                                                style={{ width: "100%", maxWidth: "300px" }}
                                                onClick={handlePayment}
                                            >
                                                Buy {total ? total.toFixed(2) : ""}
                                            </button>
                                        </div>
                                    </div>
                                </div>


                                <div className="card shadow-sm p-4 rounded mt-4">
                                    <h5 className="mb-3"></h5>

                                    <div className="row g-3">
                                        {voucherList?.length === 0 ? (
                                            <div className="col-12 text-center">No vouchers found</div>
                                        ) : (
                                            voucherList?.map((voucher) => {
                                                const createdAt = voucher.created_at;
                                                const dateObj = new Date(createdAt);

                                                let hours = dateObj.getHours();
                                                const minutes = dateObj.getMinutes().toString().padStart(2, "0");
                                                const ampm = hours >= 12 ? "PM" : "AM";
                                                hours = hours % 12 || 12;

                                                const formattedDateTime = `${dateObj.getDate().toString().padStart(2, "0")}-${(dateObj.getMonth() + 1)
                                                    .toString()
                                                    .padStart(2, "0")}-${dateObj.getFullYear()}
                                                    `;



                                                const expiryObj = new Date(voucher.expiry_date);
                                                const expiryFormatted = `${expiryObj.getDate().toString().padStart(2, "0")}-${(expiryObj.getMonth() + 1)
                                                    .toString()
                                                    .padStart(2, "0")}-${expiryObj.getFullYear()}`;

                                                const is_expired = voucher?.is_expired || voucher?.cancel_status === 1;

                                                return (
                                                    <div key={voucher?.id} className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                                        <div
                                                            className="p-3 border rounded position-relative overflow-hidden shadow-sm"
                                                            style={{
                                                                minHeight: "220px",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "space-between",
                                                                background: voucher.status === 1 
                                                                    ? "linear-gradient(135deg, #e0e0e0 0%, #b0b0b0 100%)" 
                                                                    : "linear-gradient(135deg, #fceda3 0%, #d4af37 100%)",
                                                                color: "#333",
                                                                border: "none"
                                                            }}
                                                        >
                                                            {/* Used Ribbon */}
                                                            {voucher.status === 1 && (
                                                                <div style={{
                                                                    position: "absolute", top: "15px", left: "-30px", background: "#444", color: "#fff", 
                                                                    padding: "4px 30px", transform: "rotate(-45deg)", fontSize: "10px", fontWeight: "bold",
                                                                    letterSpacing: "1px", zIndex: 10
                                                                }}>
                                                                    USED
                                                                </div>
                                                            )}
                                                            
                                                            {/* Layer 1: Background Blur if expired */}
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 0, left: 0, right: 0, bottom: 0,
                                                                    background: is_expired ? "rgba(255,255,255,0.4)" : "transparent",
                                                                    backdropFilter: is_expired ? "blur(2px)" : "none",
                                                                    zIndex: 1,
                                                                    pointerEvents: "none"
                                                                }}
                                                            />

                                                            {/* Layer 2: Content */}
                                                            <div style={{ position: "relative", zIndex: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                                                
                                                                {/* Top Header */}
                                                                <div className="d-flex justify-content-between align-items-start">
                                                                    <div>
                                                                        <h6 style={{ fontWeight: 800, margin: 0, color: "#333", letterSpacing: "0.5px" }}>GIFT VOUCHER</h6>
                                                                        <p style={{ fontSize: "12px", margin: 0, color: "#555", fontWeight: 600 }}>Worth ₹{Number(voucher?.amount).toFixed(2)}</p>
                                                                    </div>
                                                                    <div>
                                                                        <img src="/assets/iocns/newimage.png" alt="icon" style={{ width: "30px", height: "30px", objectFit: "contain", background: "rgb(77, 58, 58)", borderRadius: "8px", padding: "4px" }} />
                                                                    </div>
                                                                </div>

                                                                {/* Voucher Code Block */}
                                                                <div 
                                                                    className="my-3 py-2 px-3 text-center" 
                                                                    style={{ 
                                                                        background: "rgba(255,255,255,0.4)", 
                                                                        borderRadius: "8px", 
                                                                        border: "1px solid rgba(255,255,255,0.6)",
                                                                        cursor: "pointer" 
                                                                    }}
                                                                    onClick={() => {
                                                                        navigator.clipboard.writeText(voucher.name);
                                                                        showSnack(`Coupon code ${voucher.name} copied!`, "success");
                                                                    }}
                                                                >
                                                                    <div style={{ fontSize: "9px", fontWeight: 700, color: "#555", letterSpacing: "1px", marginBottom: "2px" }}>
                                                                        TAP TO COPY
                                                                    </div>
                                                                    <div style={{ fontSize: "16px", fontWeight: 800, letterSpacing: "3px", color: "#000", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                                                                        {voucher.name} <FaCopy size={14} color="#555" />
                                                                    </div>
                                                                </div>

                                                                {/* Expired Status Badge */}
                                                                {is_expired && (
                                                                    <div className="text-center" style={{ width: "100%", marginBottom: "5px" }}>
                                                                        <span className="badge bg-danger shadow-sm px-3 py-1" style={{ fontSize: "12px", fontWeight: "bold" }}>
                                                                            EXPIRED
                                                                        </span>
                                                                    </div>
                                                                )}

                                                                {/* Dates */}
                                                                <div style={{ fontSize: "11px", color: "#444", fontWeight: 600 }}>
                                                                    <div className="d-flex align-items-center gap-2 mb-1">
                                                                        <FaRegClock size={12} />
                                                                        <span>Issued: {formattedDateTime} {hours.toString().padStart(2, '0')}:{minutes} {ampm}</span>
                                                                    </div>
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <FaRegClock size={12} />
                                                                        <span>Valid till: {expiryFormatted}</span>
                                                                    </div>
                                                                </div>

                                                                {/* Action Buttons */}
                                                                <div className="d-flex gap-2 mt-3">
                                                                    {!is_expired && (
                                                                        <button
                                                                            className="btn btn-sm d-flex align-items-center justify-content-center gap-2"
                                                                            style={{ 
                                                                                flex: 1, 
                                                                                background: "transparent", 
                                                                                border: "1px solid rgba(0,0,0,0.2)", 
                                                                                color: "#333", 
                                                                                fontWeight: 600,
                                                                                borderRadius: "8px"
                                                                            }}
                                                                            onClick={() => {
                                                                                if (voucher?.url) {
                                                                                    window.location.href = voucher?.url;
                                                                                } else {
                                                                                    showSnack("Voucher URL not available", "error");
                                                                                }
                                                                            }}
                                                                        >
                                                                            <FiDownload size={14} /> Download
                                                                        </button>
                                                                    )}

                                                                    {voucher.status === 1 ? (
                                                                        <button
                                                                            className="btn btn-sm d-flex align-items-center justify-content-center gap-2"
                                                                            style={{ 
                                                                                flex: 1, 
                                                                                background: "#4d3a3a", 
                                                                                border: "none", 
                                                                                color: "#fff", 
                                                                                fontWeight: 600,
                                                                                borderRadius: "8px"
                                                                            }}
                                                                            disabled
                                                                        >
                                                                             Locked
                                                                        </button>
                                                                    ) : (
                                                                        !is_expired && (
                                                                            <button
                                                                                className="btn btn-sm d-flex align-items-center justify-content-center gap-2"
                                                                                style={{ 
                                                                                    flex: 1, 
                                                                                    background: "#4d3a3a", 
                                                                                    border: "none", 
                                                                                    color: "#fff", 
                                                                                    fontWeight: 600,
                                                                                    borderRadius: "8px"
                                                                                }}
                                                                                onClick={async () => {
                                                                                    const message = `
 💛 Greenheap Gold & Silver Jewellery Presents
 🎁 An Exclusive Gift Awaits You
 We’re delighted to present you with a ₹${voucher.amount} Gift Voucher, specially curated for you on the Geo Gold App.
 
 🔐 Your Voucher Code
  ${voucher.name}
 
  📅 Issued On
  ${formattedDateTime}
 
 ✨ Redeem Your Reward
 Unlock your exclusive benefit by entering the voucher code in our app.
 
 📲 Access the Experience
 Android: [https://play.google.com/store/apps/details?id=com.greenheap.gold]
 iOS: [https://apps.apple.com/in/app/com.greenheap.gold]
 
 Indulge in your reward—because you deserve it. 🌟
 `;
                                                                                    const shareData = { text: message };
                                                                                    const canNativeShare =
                                                                                        typeof navigator !== "undefined" &&
                                                                                        typeof navigator.share === "function" &&
                                                                                        navigator.canShare?.(shareData);

                                                                                    try {
                                                                                        if (canNativeShare) {
                                                                                            await navigator.share(shareData);
                                                                                            return;
                                                                                        }
                                                                                        await navigator.clipboard.writeText(message);
                                                                                        showSnack("Voucher details copied to clipboard!", "info");
                                                                                    } catch (err) {
                                                                                        console.error(err);
                                                                                        showSnack("Sharing failed!", "error");
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <FaShareAlt size={14} /> Share
                                                                            </button>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })

                                        )}
                                    </div>
                                </div>


                            </div>
                        </div>



                    </div>




                </div>




            </section >

            {/* Cancel Voucher Confirmation Modal */}
            {showCancelModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "12px",
                            padding: "32px 28px",
                            maxWidth: "380px",
                            width: "90%",
                            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
                            textAlign: "center",
                        }}
                    >
                        <div style={{ fontSize: "40px", marginBottom: "12px" }}>🎟️</div>
                        <h5 style={{ fontWeight: 700, marginBottom: "8px", color: "#222" }}>
                            Cancel Coupon?
                        </h5>
                        <p style={{ color: "#666", marginBottom: "24px", fontSize: "15px" }}>
                            Do you want to cancel the coupon? This action cannot be undone.
                        </p>
                        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                            <button
                                className="btn btn-danger fw-bold px-4"
                                onClick={async () => {
                                    setShowCancelModal(false);
                                    await cancelVoucher(cancelVoucherId);
                                    setCancelVoucherId(null);
                                }}
                            >
                                Yes, Cancel
                            </button>
                            <button
                                className="btn btn-outline-secondary fw-bold px-4"
                                onClick={() => {
                                    setShowCancelModal(false);
                                    setCancelVoucherId(null);
                                }}
                            >
                                No, Keep It
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* MUI Snackbar - same pattern as ClientDashboard */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={2000}
                onClose={handleSnackClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={handleSnackClose} severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>

        </>
    )
}
export default MyVouchers;


